import { cn } from "@frontend/shared/lib/utils";
import { motion, useTime, useTransform } from "framer-motion";

export const LoadingCirclesHoriz = ({ white }: { white?: boolean }) => {
  const time = useTime();
  const rotate = useTransform(
    time,
    [0, 4000], // For every 4 seconds...
    [0, 360], // ...rotate 360deg
    { clamp: false },
  );

  return (
    <motion.div
      data-cy="loading-circles"
      className="flex justify-center items-center w-full h-full m-auto gap-1 "
    >
      <motion.div
        className={cn(
          " bg-superscriptBlue w-[15px] h-[15px] rounded-full",
          white && "bg-white",
        )}
        animate={{
          // y: [10, -50, 10],
          scale: [0.7, 0.3, 0.7],
          // x: [0, 30, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          repeatType: "reverse",
        }}
      />
      <motion.div
        className={cn(
          " bg-superscriptBlue w-[15px] h-[15px] rounded-full",
          white && "bg-white",
        )}
        animate={{
          // y: [5, -55, 5],
          scale: [0.7, 0.3, 0.7],
          // x: [0, 10, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          repeatType: "reverse",
          delay: 0.1,
        }}
      />
      <motion.div
        className={cn(
          " bg-superscriptBlue w-[15px] h-[15px] rounded-full",
          white && "bg-white",
        )}
        animate={{
          // y: [0, -60, 0],
          scale: [0.7, 0.3, 0.7],
          // x: [0, -10, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          repeatType: "reverse",
          delay: 0.2,
        }}
      />
      <motion.div
        className={cn(
          " bg-superscriptBlue w-[15px] h-[15px] rounded-full",
          white && "bg-white",
        )}
        animate={{
          //  y: [-5, -65, -5],
          scale: [0.7, 0.3, 0.7],
          // x: [0, -30, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Number.POSITIVE_INFINITY,
          repeatType: "reverse",
          delay: 0.3,
        }}
      />
    </motion.div>
  );
};
